// @flow
import React from 'react'

export default function Pager({
  pathName,
  pageInfo,
  windowSize,
  onChangePage,
}: {
  pathName: string,
  pageInfo: {
    currentPage: number,
    previousPage: number,
    nextPage: number,
    totalPages: number,
  },
  windowSize: number,
  onChangePage?: (page: number) => void,
}) {
  const shouldShowPageSize = windowSize * 2 + 1
  let startPage = pageInfo.currentPage - windowSize
  let endPage = pageInfo.currentPage + windowSize

  startPage = startPage < 1 ? 1 : startPage
  endPage = endPage > pageInfo.totalPages ? pageInfo.totalPages : endPage
  if (endPage - startPage + 1 < shouldShowPageSize) {
    if (endPage < pageInfo.totalPages) {
      endPage = startPage + windowSize * 2
    } else {
      endPage = pageInfo.totalPages
      startPage = endPage - windowSize * 2
    }
  }

  // ページ変更イベントがセットされていたらクリックイベントをジャックする
  const onClick = (e: Event, page: number) => {
    if (onChangePage) {
      e.preventDefault()
      onChangePage(page)
    }
  }

  return (
    <div className="stay-search-list__main-nav ta-c">
      <div className="stay-page-nav">
        {pageInfo.hasPreviousPage && (
          <a
            className="stay-page-nav__numbers is-prev"
            href={`${pathName}?page=${pageInfo.previousPage}`}
            onClick={(e: Event) => onClick(e, pageInfo.previousPage)}
          >
            <i className="fa fa-angle-left" />
          </a>
        )}
        {Array.from(Array(pageInfo.totalPages), (_, i) => {
          const pageNumber = i + 1
          if (startPage > pageNumber || endPage < pageNumber) {
            return null
          } else if (pageInfo.currentPage === pageNumber) {
            return (
              <span
                key={`pager_${i}`}
                className="stay-page-nav__numbers is-current"
              >
                {pageNumber}
              </span>
            )
          }
          return (
            <a
              className="stay-page-nav__numbers"
              key={`pager_${i}`}
              href={`${pathName}?page=${pageNumber}`}
              onClick={(e: Event) => onClick(e, pageNumber)}
            >
              {pageNumber}
            </a>
          )
        })}
        {pageInfo.hasNextPage && (
          <a
            className="stay-page-nav__numbers is-next"
            href={`${pathName}?page=${pageInfo.nextPage}`}
            onClick={(e: Event) => onClick(e, pageInfo.nextPage)}
          >
            <i className="fa fa-angle-right" />
          </a>
        )}
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/shared/Pager.jsx